import { render, staticRenderFns } from "./YldsExamine.vue?vue&type=template&id=87eda1e0&scoped=true"
import script from "./YldsExamine.vue?vue&type=script&lang=js"
export * from "./YldsExamine.vue?vue&type=script&lang=js"
import style0 from "./YldsExamine.vue?vue&type=style&index=0&id=87eda1e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eda1e0",
  null
  
)

export default component.exports